import { path } from 'ramda';
import axios from 'axios';
import store from './../store';

axios.interceptors.response.use(
  function(response) {
    if (response.data.message) {
      window.$eventHub.$emit('showAlert', {
        message: response.data.message,
        type: 'success',
      });
    }

    if (response.data.data) {
      return response.data;
    }

    return response;
  },
  function(error) {
    const message = path(['response', 'data', 'message'], error);
    const flushMessagesCondition = [
      'jwt expired',
      'No authorization token was found',
    ];

    if (error.response.data.message) {
      window.$eventHub.$emit('showAlert', {
        message,
        type: 'error',
      });
    }

    if (flushMessagesCondition.includes(message)) {
      window.$eventHub.$emit('flushUser', { message });
    }

    return Promise.reject(error);
  },
);
